import type { RouteObject } from "react-router";
import { LoginPage } from "./auth/LoginPage";
import { RequireSession } from "./auth/RequireSession";
import { AccountsPage } from "./features/accounts/AccountsPage";
import { BudgetsPage } from "./features/budgets/BudgetsPage";
import { CategoriesPage } from "./features/categories/CategoriesPage";
import { DashboardPage } from "./features/dashboard/DashboardPage";
import { RecurrencesPage } from "./features/recurrences/RecurrencesPage";
import { TransactionFormPage } from "./features/transactions/TransactionFormPage";
import { TransactionsPage } from "./features/transactions/TransactionsPage";
import { WorkspaceLayout } from "./layout/WorkspaceLayout";
import { NotFound } from "./pages/NotFound";
import { RootRedirect } from "./pages/RootRedirect";
import { RootLayout } from "./RootLayout";

export const routes: RouteObject[] = [
  {
    element: <RootLayout />,
    children: [
      { path: "/entrar", element: <LoginPage /> },
      {
        element: <RequireSession />,
        children: [
          { path: "/", element: <RootRedirect /> },
          {
            path: "/w/:wid",
            element: <WorkspaceLayout />,
            children: [
              { index: true, element: <DashboardPage /> },
              { path: "transactions", element: <TransactionsPage /> },
              { path: "transactions/new", element: <TransactionFormPage /> },
              { path: "transactions/:id", element: <TransactionFormPage /> },
              { path: "accounts", element: <AccountsPage /> },
              { path: "categories", element: <CategoriesPage /> },
              { path: "budgets", element: <BudgetsPage /> },
              { path: "recurrences", element: <RecurrencesPage /> },
              // Telas pesadas ou pouco visitadas ficam fora do JS inicial (c23).
              {
                path: "reports",
                lazy: async () => ({
                  Component: (await import("./features/reports/ReportsPage")).ReportsPage,
                }),
              },
              {
                path: "admin",
                lazy: async () => ({
                  Component: (await import("./features/admin/PlatformInvitationsPage"))
                    .PlatformInvitationsPage,
                }),
              },
              {
                path: "settings",
                lazy: async () => ({
                  Component: (await import("./features/settings/SettingsLayout")).SettingsLayout,
                }),
                children: [
                  {
                    index: true,
                    lazy: async () => ({
                      Component: (await import("./features/settings/WorkspaceSettingsPage"))
                        .WorkspaceSettingsPage,
                    }),
                  },
                  {
                    path: "members",
                    lazy: async () => ({
                      Component: (await import("./features/settings/MembersPage")).MembersPage,
                    }),
                  },
                  {
                    path: "api-keys",
                    lazy: async () => ({
                      Component: (await import("./features/settings/AccessPages")).ApiKeysPage,
                    }),
                  },
                  {
                    path: "agents",
                    lazy: async () => ({
                      Component: (await import("./features/settings/AccessPages")).AgentsPage,
                    }),
                  },
                  {
                    path: "email",
                    lazy: async () => ({
                      Component: (await import("./features/settings/EmailAuditPages")).EmailPreferencesPage,
                    }),
                  },
                  {
                    path: "devices",
                    lazy: async () => ({
                      Component: (await import("./features/settings/DevicesPage")).DevicesPage,
                    }),
                  },
                  {
                    path: "audit",
                    lazy: async () => ({
                      Component: (await import("./features/settings/EmailAuditPages")).AuditPage,
                    }),
                  },
                ],
              },
            ],
          },
        ],
      },
      { path: "*", element: <NotFound /> },
    ],
  },
];
